module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAcElEQVR42u3aMQEAIADDsPl3gAVMjgMZy1EDuZu2WS4AAAAAAAAAAAAAAKwDJJ0KAAAAAAAAAAAAAAAAANomuV0KAAAAAAAAAAAAAAAAAH4nnQoAAAAAAAAAAAAAAAAAABglAQAAAAAAAAAAAABY6wFqxW624E1aHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Armenia.png
// module id = 1ErE
// module chunks = 0 62 63